import { Routes } from '@angular/router';
import { DwLanguageService } from '@webdpt/framework';
import { Fxed020S01Component } from './fxed020-s01.component';
var ɵ0 = {
    dwRouteData: {
        programId: 'fxed020'
    },
    i18n: ['common']
};
var routes = [
    {
        path: 'home',
        pathMatch: 'prefix',
        component: Fxed020S01Component,
        data: ɵ0,
        resolve: {
            transaction: DwLanguageService
        },
        loadChildren: './fxed020-pages/fxed020-pages.module#Fxed020PagesModule'
        // children: [
        //   {
        //     path: '',
        //     pathMatch: 'prefix',
        //     // component: Fxed020S01Component,
        //     loadChildren: './fxed020-pages/fxed020-pages.module#Fxed020PagesModule',
        //     // children: [
        //     //   //dwAttachTabbedRoutes(MODULE_ROUTES),
        //     //   ...MODULE_ROUTES
        //     // ]
        //   }
        // ]
    },
];
var Fxed020RoutingModule = /** @class */ (function () {
    function Fxed020RoutingModule() {
    }
    return Fxed020RoutingModule;
}());
export { Fxed020RoutingModule };
export { ɵ0 };
